import { Routes } from '@models/routes';
import { lazy } from 'react';

const Questionnaires = lazy(() =>
  import('@pages/questionnaire/Questionnaire').then((p) => ({
    default: p.Questionnaire,
  }))
);

export const QuestionnaireRoutes: Routes = [
  {
    path: '/questionnaire/:id',
    component: Questionnaires,
  },
  {
    path: '/q/:slug',
    component: Questionnaires,
  },
];
